import { Menu, toJson } from "../models/menu";
import { ADMIN_API_PREFIX, API_PREFIX } from "./constant";
import { Request } from "./request";

export function getAvailableMenuList(str?: string, tenantId?: string): Request {
  return {
    url:
      str == '用户'
        ? `${ADMIN_API_PREFIX}/tenantmenu/list`
        : `${ADMIN_API_PREFIX}/menu/list`,
    method: 'GET',
    params: {
      tenantId,
      flag: Number(tenantId) == 1 ? 2 : 1,
      current: 1,
      size: 1000,
    },
  }
}

export function getAvailableMenuLists(
  str?: string,
  tenantId?: string,
  type?: any
): Request {
  return {
    url: `${ADMIN_API_PREFIX}/menu/listByVersions`,
    method: 'GET',
    params: {
      tenantId,
      flag: Number(tenantId) == 1 ? 2 : 1,
      type,
      current: 1,
      size: 1000,
    },
  }
}


// 三级菜单全部列表
export function getAvailableThreeMenuLists(
  str?: string,
  tenantId?: string,
  type?: any
): Request {
  return {
    url: `${ADMIN_API_PREFIX}/menu/listThirdByVersions`,
    method: 'GET',
    params: {
      tenantId,
      flag: Number(tenantId) == 1 ? 2 : 1,
      type,
      current: 1,
      size: 1000,
    },
  }
}


export function getGrantedMenuList(tenantId: string, userId?: string): Request {
  return {
    url: userId
      ? `${ADMIN_API_PREFIX}/tenant/usermenu/list`
      : `${ADMIN_API_PREFIX}/tenantmenu/list`,
    method: 'GET',
    params: {
      tenantId,
      flag: Number(tenantId) == 1 ? 2 : 1,
      userId,
      current: 1,
      size: 1000,
    },
  }
}

// 三级菜单选中

export function getGrantedThreeMenuList(tenantId: string,): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenantmenu/listThirdMenu`,
    method: 'GET',
    params: {
      tenantId,
      flag: Number(tenantId) == 1 ? 2 : 1,
      current: 1,
      size: 1000,
    },
  }
}

export function getTenantAvailableMenuList(): Request {
  return {
    url: `${API_PREFIX}/blade-user/tenantmenu/list`,
    method: "GET",
    params: {
      current: 1,
      size: 1000,
    },
  };
}

export function getUserGrantedMenuList(userId?: string): Request {
  return {
    url: `${API_PREFIX}/blade-user/usermenu/usermenu/list`,
    method: "GET",
    params: {
      userId,
      current: 1,
      size: 1000,
    },
  };
}

export function grantMenus(
  tenantId: string,
  userId: string | undefined,
  menuIds: string[]
): Request {
  return {
    url: userId
      ? `${ADMIN_API_PREFIX}/tenant/user/menu/add`
      : `${ADMIN_API_PREFIX}/tenantmenu/add`,
    method: "POST",
    body: {
      tenantId,
      userId,
      menuIds,
    },
  };
}

export function grantUserMenus(userId: string, menuIds: string[]): Request {
  return {
    url: `${API_PREFIX}/blade-user/usermenu/add`,
    method: "POST",
    body: {
      userId,
      menuIds,
    },
  };
}

// 三级菜单保存
export function grantThreeMenus(
  tenantId: string,
  menuIds: string[]
): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenantmenu/addThird`,
    method: 'POST',
    body: {
      tenantId,
      menuIds,
    },
  }
}


export function createMenu(menu: Menu): Request {
  return {
    url: `${ADMIN_API_PREFIX}/menu/add`,
    method: "POST",
    body: toJson(menu),
  };
}


export function updateMenu(menu: Menu): Request {
  return {
    url: `${ADMIN_API_PREFIX}/menu/update`,
    method: "POST",
    body: toJson(menu),
  };
}

export function removeMenu(menu: Menu): Request {
  return {
    url: `${ADMIN_API_PREFIX}/menu/remove`,
    method: "POST",
    params: {
      ids: menu.id,
    },
  };
}

//机构菜单
export function thirdTenantMenuTreeFn(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/menu/listTenantMenuByVersions`,
    method: "GET",
    params,
  };
}

export function setThirdTenantMenuTreeFn(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/menu/saveTenantMenuByVersions`,
    method: "POST",
    body,
  };
}

//员工菜单
export function thirdMemberMenuTreeFn(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/usermenu/listNEW`,
    method: "GET",
    params,
  };
}

export function setThirdMemberMenuTreeFn(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/user/menu/save`,
    method: "POST",
    body,
  };
}